__turbopack_context__.v({
  "block-img": "Pn3v5W_block-img",
  "carousel-active": "Pn3v5W_carousel-active",
  "content": "Pn3v5W_content",
  "hero-carousel-wrapper-indicators": "Pn3v5W_hero-carousel-wrapper-indicators",
  "paper": "Pn3v5W_paper",
  "paper-carousel-title-divider": "Pn3v5W_paper-carousel-title-divider",
  "section": "Pn3v5W_section",
  "sub-title": "Pn3v5W_sub-title",
});
